<template>
    <div>
        <div class="text-right my-3">
            <button type="button" class="btn btn-primary"
                    data-toggle="modal" data-target="#generate-pdf-modal">{{ $lang('Raport potwierdzający zaliczenie') }}
            </button>
        </div>

        <div class="modal fade" id="generate-pdf-modal" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="generate-pdf-modal-title">
                            {{ $lang('Wybierz rodzaj raportu do wygenerowania') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body py-4 text-center">
                        <button type="button" class="btn btn-primary mr-5" @click="exportFullReport">{{
                                $lang('Pełny raport')
                            }}
                        </button>
                        <button type="button" class="btn btn-primary ml-5" @click="exportShortReport">{{
                                $lang('Krótki raport')
                            }}
                        </button>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">{{ $lang('Zamknij') }}
                        </button>

                    </div>

                    <div id="generatingMessage" class="text-center py-2" style="display:none;">
                        {{ $lang('Generowanie pliku PDF...') }}
                    </div>

                    <div id="errorMessage" class="text-danger text-center py-2" style="display: none;">
                        {{ $lang('Nie udało się wygenerować pliku PDF.') }}
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "generate-completed-survey-pdf",
    props: {
        csrf: String,
        full_report_generate_route: String,
        short_report_generate_route: String,
        survey: Object,
        survey_type: Object,
        survey_questions: Array,
        survey_answers: Object,
        correct_answers: Object,
        pdf_name: String,
    },
    data() {
        return {
            exportDataFullReport: {
                surveyId: this.survey.id,
                surveyTypeId: this.survey_type.id,
                surveyTitle: this.survey_type.name,
                library: this.survey.library.name,
                date: this.survey.created_at,
                correctAnswersPercentage: this.survey.correct_answers_percentage,
                surveyQuestions: this.survey_questions,
                surveyAnswers: this.survey_answers,
                correctAnswers: this.correct_answers,
            },
            exportDataShortReport: {
                surveyId: this.survey.id,
                surveyTypeId: this.survey_type.id,
                library: this.survey.library.name,
                date: this.survey.created_at,
                surveyTitle: this.survey_type.name,
                correctAnswersPercentage: this.survey.correct_answers_percentage,
            },
        }
    },
    methods: {
        exportFullReport() {
            let self = this;
            $("#generatingMessage").show();
            axios({
                method: 'post',
                url: this.full_report_generate_route,
                data: this.exportDataFullReport,
                responseType: 'blob',
            }).then(function (response) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                // works in IE11
                if (typeof window.navigator.msSaveBlob === 'function') {
                    window.navigator.msSaveBlob(
                        response.data,
                        self.pdf_name + ' - pełny raport.pdf'
                    );
                } else {
                    link.setAttribute('download', self.pdf_name + ' - pełny raport.pdf');
                    document.body.appendChild(link);
                    link.click();
                }
                $("#errorMessage").hide();
                $("#generate-pdf-modal").modal('hide');
            }).catch(function (error) {
                $("#errorMessage").show();
                console.log(error);
            }).finally(function () {
                $("#generatingMessage").hide();
            });
        },
        exportShortReport() {
            let self = this;
            $("#generatingMessage").show();
            axios({
                method: 'post',
                url: this.short_report_generate_route,
                data: this.exportDataShortReport,
                responseType: 'blob',
            }).then(function (response) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                // works in IE11
                if (typeof window.navigator.msSaveBlob === 'function') {
                    window.navigator.msSaveBlob(
                        response.data,
                        self.pdf_name + ' - skrócony raport.pdf'
                    );
                } else {
                    link.setAttribute('download', self.pdf_name + ' - skrócony raport.pdf');
                    document.body.appendChild(link);
                    link.click();
                }
                $("#errorMessage").hide();
                $("#generate-pdf-modal").modal('hide');
            }).catch(function (error) {
                $("#errorMessage").show();
                console.log(error);
            }).finally(function () {
                $("#generatingMessage").hide();
            });
        }
    }
}
</script>

<style scoped>

</style>
